import { Typography, Box } from '@mui/material';
import ComingSoonImg from '../icons/ComingSoon.svg';

export default function ComingSoon(props: any) {
  return (
    <Box sx={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow:'auto' }}>
      <Box sx={{ display: 'flex', justifyContent:'center', flexDirection:'column', alignItems:'center' }}>
        <img src={ComingSoonImg} alt="Coming soon" style={{ height: '400px', width: '400px' }} />
        <Typography
          style={{
            fontFamily: "'Work Sans', sans-serif",
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '24px',
            lineHeight: '22px',
            color: '#000000',
            marginTop: '28px',
            marginBottom: '28px',
          }}
        >
          Coming soon...
        </Typography>
      </Box>
    </Box>
  );
}
